(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ado-feature-tabs"] && !Shopify.designMode) return;
  try {
    
class TabsFeatureContainer extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });

        const tabsWrapper = document.createElement('div');
        tabsWrapper.classList.add('tabs');

        const slot = document.createElement('slot');
        slot.addEventListener('slotchange', () => {
            const tabs = this.querySelectorAll('tab-feature-panel');
            tabs.forEach((tab, index) => {
                const button = document.createElement('button');
                button.textContent = tab.getAttribute('name');
                button.addEventListener('click', () => this.selectTab(index));
                if (index === 0) {
                    button.classList.add('active');
                }
                tabsWrapper.appendChild(button);

                if (index === 0) {
                    tab.classList.add('active');
                }
            });
        });

        this.shadowRoot.append(tabsWrapper, slot);

        const style = document.createElement('style');
        style.textContent = `
            .tabs {
                display: flex;
          border-bottom:1px solid #e49c3a;
              
            }
            .tabs button {
                flex: 1;
                flex-shrink: 1;
                padding: 10px;
                background:#ececec;
                border: none;
                cursor: pointer;
                font-size:18px;
                font-weight:700px;
             
                transition: border-bottom-color 0.3s;
                box-sizing: content-box;

            }
            .tabs button.active {
                background: #e49c3a;
                color: #fff;
            }
            ::slotted(tab-feature-panel) {
                display: none;
                border: 1px solid #ccc;
                border-top: none;
                transition: color 0.15s ease-in-out 0s;
            }
            ::slotted(tab-feature-panel.active) {
                display: block;
                transition:color 0.15s ease-in-out 0s;
            }
        `;
        this.shadowRoot.append(style);
    }

    selectTab(index) {
        const tabs = this.querySelectorAll('tab-feature-panel');
        const buttons = this.shadowRoot.querySelectorAll('.tabs button');
        tabs.forEach((tab, i) => {
            if (i === index) {
                tab.classList.add('active');
                buttons[i].classList.add('active');
            } else {
                tab.classList.remove('active');
                buttons[i].classList.remove('active');
            }
        });
    }
}

class TabFeaturePanel extends HTMLElement {
    constructor() {
        super();
    }
}

customElements.define('tabs-feature-container', TabsFeatureContainer);
customElements.define('tab-feature-panel', TabFeaturePanel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ado-image-with-text-overlay"] && !Shopify.designMode) return;
  try {
    
let lastKnownScrollPosition = 0;
let ticking = false;
function handleScroll() {
    var button = document.querySelector('.button--fixed');
    if (!button) return; 
    var rect = button.getBoundingClientRect();
    var isFixed = button.classList.contains('ado-fixed');
    if (lastKnownScrollPosition > 450 && !isFixed) {
        button.classList.add('ado-fixed');
        document.querySelector('.ado-image-text-overlay').style.zIndex = 1000;
    } 
    else if (rect.top < 450 && isFixed) {
        button.classList.remove('ado-fixed');
        document.querySelector('.ado-image-text-overlay').style.zIndex = 1;
    }
}
document.addEventListener("scroll", (event) => {
  lastKnownScrollPosition = window.scrollY;
  if (!ticking) {
    window.requestAnimationFrame(() => {
      handleScroll(lastKnownScrollPosition);
      ticking = false;
    });
    ticking = true;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ado-tabs"] && !Shopify.designMode) return;
  try {
    
class TabsContainer extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });

        const tabsWrapper = document.createElement('div');
        tabsWrapper.classList.add('tabs');

        const slot = document.createElement('slot');
        slot.addEventListener('slotchange', () => {
            const tabs = this.querySelectorAll('tab-panel');
            tabs.forEach((tab, index) => {
                const button = document.createElement('button');
                button.textContent = tab.getAttribute('name');
                button.addEventListener('click', () => this.selectTab(index));
                if (index === 0) {
                    button.classList.add('active');
                }
                tabsWrapper.appendChild(button);

                if (index === 0) {
                    tab.classList.add('active');
                }
            });
        });

        this.shadowRoot.append(tabsWrapper, slot);

        const style = document.createElement('style');
        style.textContent = `
            .tabs {
                display: flex;
                gap:10px;
                margin:20px 0;
            }
            .tabs button {
                flex: 1;
                flex-shrink: 1;
                padding: 10px;
                background:#ececec;
                border: none;
                cursor: pointer;
                border-bottom: 2px solid transparent;
                transition: border-bottom-color 0.3s;
                border-radius: 4px;
                box-sizing: content-box;
                border:1px solid  #fff;

            }
            .tabs button.active {
                background: #e49c3a;
                color: #fff;
            }
            ::slotted(tab-panel) {
                display: none;
                border: 1px solid #ccc;
                border-top: none;
                transition: color 0.15s ease-in-out 0s;
            }
            ::slotted(tab-panel.active) {
                display: block;
                transition:color 0.15s ease-in-out 0s;
            }
        `;
        this.shadowRoot.append(style);
    }

    selectTab(index) {
        const tabs = this.querySelectorAll('tab-panel');
        const buttons = this.shadowRoot.querySelectorAll('.tabs button');
        tabs.forEach((tab, i) => {
            if (i === index) {
                tab.classList.add('active');
                buttons[i].classList.add('active');
            } else {
                tab.classList.remove('active');
                buttons[i].classList.remove('active');
            }
        });
    }
}

class TabPanel extends HTMLElement {
    constructor() {
        super();
    }
}

customElements.define('tabs-container', TabsContainer);
customElements.define('tab-panel', TabPanel);

  } catch(e) { console.error(e); }
})();
})();
